import { render, staticRenderFns } from "./PAppUpdate.vue?vue&type=template&id=08c18c31&"
import script from "./PAppUpdate.vue?vue&type=script&lang=ts&"
export * from "./PAppUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports